import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initializeAppearance } from './appearance';
import { LocaleProvider } from './i18n/context';
import { platform } from './platform';
import { applyRobotsMeta } from './seo';
import './styles.css';

initializeAppearance();

// Launch decision 10: only production is meant to be found by search engines.
applyRobotsMeta(document, window.location.hostname);

// Per-OS styling is an attribute selector (ADR-029 §1): web, ios or android.
document.documentElement.dataset['platform'] = platform.kind;

// The language (ADR-031): the choice this install stored, else the host's languages, else
// English — resolved before the first screen renders.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LocaleProvider
      systemLanguages={() => navigator.languages}
      store={{ load: platform.loadLanguage, save: platform.storeLanguage }}
    >
      <App />
    </LocaleProvider>
  </StrictMode>,
);
